/**
 * Converts a snake_case string to PascalCase.
 *
 * @example
 * snakeToPascalCase("button_pressed_medicare_continue_access")
 * // => "ButtonPressedMedicareContinueAccess"
 */
export function snakeToPascalCase(str: string): string {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
}
